import { TranslationKey } from './../../../../types/translation/TranslationKey';

import React from 'react';
import { Contact } from '../../../../types/contact';
import { t } from '../../../../types/translation/Translator';
import { toFilterString } from '../../../../util/string.util';
import { AddressFilter } from '../AddressFilter';
import { BaseFilter } from '../common/BaseFilter';

export class ContactFilter extends BaseFilter<Contact> {
  toLabel(): string {
    return t(TranslationKey.contact).singular.label;
  }

  toCount(): number {
    return 0;
  }

  toIcon(): JSX.Element {
    return <></>;
  }

  toDropdownContent(): JSX.Element {
    return <></>;
  }

  toInnerContent(): string | JSX.Element {
    return <></>;
  }

  search(item: Contact, textFilter: string) {
    const addressFilter = new AddressFilter();
    if (toFilterString(item.name).includes(textFilter)) {
      return true;
    }

    return false;
  }
}
